import React, { useState } from 'react';
import { Bell, CheckCircle, Loader2, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const NewsletterSignup = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    
    setTimeout(() => {
      setStatus('success');
      window.location.href = `mailto:hello@summarygpt.com?subject=Newsletter%20Signup&body=Please%20add%20me%20to%20the%20newsletter%20and%20notify%20me%20about%20future%20releases.%0A%0AEmail:%20${encodeURIComponent(email)}`;
    }, 1000);
  };

  if (status === 'success') {
    return (
      <div className="text-center py-8">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-emerald-500/10 border border-emerald-500/25 mb-5">
          <CheckCircle className="w-7 h-7 text-emerald-400" />
        </div>
        <h3 className="text-xl font-bold text-white mb-2">You're on the list!</h3>
        <p className="text-slate-400 text-sm">We'll notify you about new releases and updates.</p>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="flex-1 h-12 px-4 bg-slate-900/60 border-slate-700/80 text-white placeholder:text-slate-500 focus:border-amber-500/50 focus:ring-amber-500/20 rounded-xl text-sm"
        />
        <Button
          type="submit"
          disabled={status === 'loading'}
          className="h-12 px-6 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-400 hover:to-orange-400 text-slate-900 font-semibold shadow-lg shadow-amber-500/20 hover:shadow-amber-500/30 transition-all duration-300 border-0 gap-2 disabled:opacity-50 rounded-xl"
        >
          {status === 'loading' ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <>
              <Bell className="w-4 h-4" />
              Notify Me
            </>
          )}
        </Button>
      </form>
    );
  }

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-amber-500/10 border border-amber-500/25 mb-5">
          <Sparkles className="w-7 h-7 text-amber-400" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
          Stay in the loop
        </h2>
        <p className="text-slate-400">
          Get notified about new tools, features, and releases. No spam, ever.
        </p>
      </div>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="h-14 px-5 bg-slate-900/60 border-slate-700/80 text-white placeholder:text-slate-500 focus:border-amber-500/50 focus:ring-amber-500/20 rounded-xl text-base text-center"
        />
        <Button
          type="submit"
          disabled={status === 'loading'}
          className="w-full h-14 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-400 hover:to-orange-400 text-slate-900 font-semibold shadow-lg shadow-amber-500/25 hover:shadow-amber-500/35 transition-all duration-300 border-0 gap-2 disabled:opacity-50 rounded-xl text-lg"
        >
          {status === 'loading' ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <>
              <Bell className="w-5 h-5" />
              Get Notified
            </>
          )}
        </Button>
      </form>
      
      <p className="text-center text-slate-500 text-xs mt-4">
        Unsubscribe anytime. We respect your privacy.
      </p>
    </div>
  );
};

export default NewsletterSignup;
